import { useState } from 'react';
import { useStore } from '../state/store';
import { useTheme } from '../theme/useTheme';
import { decideReclaim } from '../state/actions';
import { hasSeenDisclaimer, markDisclaimerSeen } from '../state/storage';
import { Button } from './ui';

/** Spec §4: the variant's satire disclaimer. */
export function DisclaimerText() {
  const th = useTheme();
  return (
    <div className="disclaimer">
      <p>
        <strong>{th.t.disclaimer.lead}</strong>
      </p>
      <p>{th.t.disclaimer.body}</p>
    </div>
  );
}

/** Spec §4: shown on first launch. */
export function FirstLaunchDisclaimer() {
  const [open, setOpen] = useState(() => !hasSeenDisclaimer());
  if (!open) return null;
  return (
    <div className="overlay" role="dialog" aria-modal="true" aria-labelledby="disclaimer-title">
      <div className="sheet">
        <h2 id="disclaimer-title" className="section-label">
          Before you begin
        </h2>
        <DisclaimerText />
        <Button
          onClick={() => {
            markDisclaimerSeen();
            setOpen(false);
          }}
        >
          Understood
        </Button>
      </div>
    </div>
  );
}

export function ConnectionBar() {
  const connected = useStore((s) => s.connected);
  if (connected) return null;
  return (
    <div className="connection-bar" role="status">
      Reconnecting…
    </div>
  );
}

/** Host only (spec §61). */
export function ReclaimRequests() {
  const requests = useStore((s) => s.reclaimRequests);
  if (requests.length === 0) return null;
  return (
    <div className="reclaims">
      {requests.map((r) => (
        <div className="reclaim" key={r.requestId} role="alert">
          <p>Someone wants to reclaim {r.playerName}’s seat.</p>
          <div className="row">
            <Button variant="secondary" onClick={() => void decideReclaim(r.requestId, false)}>
              Deny
            </Button>
            <Button onClick={() => void decideReclaim(r.requestId, true)}>Approve</Button>
          </div>
        </div>
      ))}
    </div>
  );
}
